import BASE_RULE from '../baseRule';
import {SearchTypeAttributeHistory} from './constants';
import {AttributeHistoryRule} from './types';

export const attributeHistoryRuleDefaults: AttributeHistoryRule = {
	...BASE_RULE,
	elementType: SearchTypeAttributeHistory,
	elementSubType1: 4,
	elementValue1: 0,
	elementValue3: '',
};

export default attributeHistoryRuleDefaults;
